export enum RoleTypeEnum {
    CLIENT_ROLE="client",
    ORGANIZATION_ROLE="organization"
}

export enum USERTYPE{
  TENENT= 0,
    CLIENT= 1,
    APPUSER= 2,
    SUBCLIENT=3
}
